export const aboutMe = [
     {
          name: 'name',
          desc: 'Onu Emmanuel Ugochukwu'
     },

     {
          name: 'brand',
          desc: 'Emix - ( Photography, designs, studios )'
     },
     {
          name: 'email',
          desc: 'emixOnu95@gmail.com'
     },
     {
          name: 'services',
          desc: 'Graphics design / Photography / Videography'
     },
     {
          name: 'objective',
          desc: ' Create captivating visual content that exceeds client expectations using my skills in photography, graphic design, and videography'
     },
     {
          name: 'education',
          desc: 'B.Eng, Electrical and Electronics Engineering. University of Technology Minna, Nigeria'
     },
   
]